import http from './http'

function mapPage (res) {
  var page = res.data
  return {
    items: page.content || [],
    total: page.totalElements || 0,
    hasMore: !page.last
  }
}

export function listUsers (params) {
  return http.get('/users', { params: params }).then(mapPage)
}

export function changeUserRole (userId, role) {
  return http.patch('/users/' + userId + '/role', { role: role }).then(function (res) {
    return res.data
  })
}

/**
 * List all active engineers with their in-flight job counts. ADMIN role required.
 * @returns {Promise<Array<{ engineerId: string, displayName: string, email: string, activeJobCount: number, activeJobs: Array }>>}
 */
export function listEngineers () {
  return http.get('/jobs/engineers').then(function (res) {
    return res.data
  })
}
